function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
import { useArchiveFileReadQueryPromise } from '@isyc-react/oc-api';
import React from 'react';
import { CardCourseComponent, CardCourseHeaderComponent, ImageModeToUse } from "../card";
import { useOpenMoodleLink } from "../../../utils";
export const EnrollmentCourseStructureCardComponent = props => {
  const {
    enrollmentCourse,
    card = {}
  } = props;
  const openMoodleLink = useOpenMoodleLink();
  const {
    onClick = () => openMoodleLink('/course/view.php', 'id=' + enrollmentCourse.courseMoodleId)
  } = card;
  const useFile = useArchiveFileReadQueryPromise();
  const [imageBase64, setImageData] = React.useState();

  //Load image by id
  React.useEffect(() => {
    if (enrollmentCourse.courseImage) {
      useFile({
        id: enrollmentCourse.courseImage
      }).then(r => {
        if (r.data && r.data.archive_readFile) {
          setImageData(r.data.archive_readFile.content);
        }
      });
    } else {
      setImageData(undefined);
    }
  }, [enrollmentCourse.courseImage]);
  const data = React.useMemo(() => {
    return {
      id: enrollmentCourse.courseId,
      name: enrollmentCourse.courseName,
      startingDate: enrollmentCourse.initialDate,
      endingDate: enrollmentCourse.finalDate,
      description: enrollmentCourse.courseDescription,
      objective: enrollmentCourse.courseObjective,
      duration: enrollmentCourse.courseDuration,
      moodleId: enrollmentCourse.courseMoodleId
    };
  }, []);
  return /*#__PURE__*/React.createElement(CardCourseComponent, _extends({
    data: data,
    onClick: () => {
      onClick && onClick(data);
    },
    Components: {
      Header: p => /*#__PURE__*/React.createElement(CardCourseHeaderComponent, _extends({}, p, {
        imageModeToUse: imageBase64 ? ImageModeToUse.BASE64 : undefined,
        imageBase64: imageBase64
      }))
    }
  }, card));
};